import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Alert,
  Grid,
  Box,
} from '@mui/material';
import { ratingApi } from '../../services/api'; // This will be created later

const RatingLevelDialog = ({ open, onClose, mode, schemeId, level, onUpdate, ratingSchemes }) => {
  const [name, setName] = useState('');
  const [value, setValue] = useState('');
  const [description, setDescription] = useState('');
  const [colorCode, setColorCode] = useState('#ffffff');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      if (mode === 'edit' && level) {
        setName(level.name || '');
        setValue(level.value || '');
        setDescription(level.description || '');
        setColorCode(level.color_code || '#ffffff');
      } else {
        setName('');
        setValue('');
        setDescription('');
        setColorCode('#ffffff');
      }
      setError(null);
    }
  }, [open, mode, level]);

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);

    const levelData = {
      scheme_id: schemeId,
      name,
      value: parseInt(value, 10),
      description,
      color_code: colorCode,
    };

    if (isNaN(levelData.value)) {
        setError('Value must be a number.');
        setLoading(false);
        return;
    }

    try {
      if (mode === 'create') {
        await ratingApi.createLevel(levelData);
      } else {
        await ratingApi.updateLevel(level.id, levelData);
      }
      const parentScheme = ratingSchemes.find(s => s.id === schemeId);
      if (parentScheme) {
        onUpdate(parentScheme.asset_type_id);
      }
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || `Failed to ${mode} rating level.`);
      console.error(`Error ${mode}ing rating level:`, err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{mode === 'create' ? 'Create New Rating Level' : 'Edit Rating Level'}</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={8}>
            <TextField
              autoFocus
              label="Level Name"
              type="text"
              fullWidth
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Value"
              type="number"
              fullWidth
              variant="outlined"
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Description"
              type="text"
              fullWidth
              multiline
              rows={2}
              variant="outlined"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <label htmlFor="color-picker">Color Code:</label>
                <input
                    id="color-picker"
                    type="color"
                    value={colorCode}
                    onChange={(e) => setColorCode(e.target.value)}
                    style={{ height: '40px', width: '100px', border: '1px solid #ccc', borderRadius: '4px' }}
                />
                <TextField
                    label="Hex Code"
                    variant="outlined"
                    size="small"
                    value={colorCode}
                    onChange={(e) => setColorCode(e.target.value)}
                />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : (mode === 'create' ? 'Create' : 'Save Changes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RatingLevelDialog;